import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { EmailStats, LeadsListMappings, LeadsListStatus } from './types';

type GetLeadsListMetadataProps = {
  artistId: string;
  listId: string;
};

/* eslint-disable camelcase */
export type GetLeadsListMetadataResponse = ObjectResponse<{
  id: string;
  list_name: string;
  file_processing_status: LeadsListStatus;
  file_column_mapping: LeadsListMappings[];
  count: number;
  created_at: string;
  email_stats: EmailStats;
  updated_at: string;
}>;
/* eslint-enable camelcase */

export async function getLeadsListMetadata({ artistId, listId }: GetLeadsListMetadataProps) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!listId) throw new Error('List ID is required');

  const url = `/web/studio/artists/${artistId}/leads-lists/${listId}`;
  const response = await api.executeGetRequest<GetLeadsListMetadataResponse>(url);

  return response.data;
}
